<footer class="footer-section">
  <div class="footer-list">
    <div class="footer-item footer-small-item">
      <div>
        <span><a href="#">{{ 'HELP' | translate }}</a></span>
      </div>
    </div>

    <div class="footer-item footer-small-item">
      <div>
        <span><a href="#">{{ 'PRIVACY_POLICY' | translate }}</a></span>
      </div>
    </div>

    <div class="footer-item">
      <div>
        <span><a href="#">{{ 'TERMS_OF_USE' | translate }}</a></span>
      </div>
    </div>

    <!--<div class="footer-item">
      <div>
        <span>©{{year}} Astimax | {{ 'ALL_RIGHTS_RESERVED' | translate }}.</span>
      </div>
    </div>-->
  </div>
</footer>
